import React, { useState, useEffect, useRef } from 'react';
import 'datatables.net-bs5';
import 'datatables.net-bs5/css/dataTables.bootstrap5.min.css';
import Swal from 'sweetalert2';
import HelpSite from "../../../Common/HelpLink";
import BASE_URL from "../../../../config/config";
import CompanySetupController from "../../../SuperAdmin/Controller/Client/SACompanyListController";
import { fetchActiveDateFormat } from '../../../Common/fetchDateFormat';
import { formatDateWithFns } from '../../../Common/DateInputFormat';
import useDateFormat from '../../../Common/fetchDateFormat';
function DatabasePage() {
    const activeDateFormat = useDateFormat();
    const HelpLink = localStorage.getItem('HelpLink');
    const [DatabaseBackup, setDatabaseBackup] = useState([]);
    const [loading, setLoading] = useState(false);
    const fetchDownloadBackup = async () => {
        try {
            let dbBackup = await CompanySetupController.DownloadDatabaseBackup();
            dbBackup = dbBackup.filter(x => x.UserID.toString() === localStorage.getItem("UserID").toString());
            setDatabaseBackup(dbBackup);

        } catch (error) {
            console.error('Error fetching currencies:', error);
        }
    };
    const handleDownloadBackup = async () => {
        try {
            setLoading(true);
            const response = await CompanySetupController.DownloadBackup();
            if (response.data) {
                Swal.fire(
                    'Success!',
                    'Backup request submitted. Please check status later.',
                    'success'
                );
            }

        } catch (err) {
            console.error('Error downloading backup:', err);
            //alert('Failed to download backup');
        }
        finally {
            setLoading(false);
        }
    };
    const handleDownload = async (FilePath) => {
        try {
            setLoading(true);
            const filePath = FilePath;
            const fileName = filePath.split('/').pop();
            const downloadUrl = `${BASE_URL}/uploads/backups/${fileName}`;
            const link = document.createElement('a');
            link.href = downloadUrl;
            link.setAttribute('download', fileName); // optional
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);


        } catch (err) {
            console.error('Error downloading backup:', err);
            //alert('Failed to download backup');
        }
        finally {
            setLoading(false);
        }
    };
    useEffect(() => {
        fetchDownloadBackup();
    }, []);
    return (
        <div>
            {loading && (
                <div class="loading">
                    <div class="d-table">
                        <div class="d-tablecell">
                            <span class="loader">
                                <span class="loader-inner"></span>
                            </span>
                        </div>
                    </div>
                </div>
            )}
            <div className="row mb-3">
                <div className="col-sm-12" style={{ "textAlign": "right" }}>
                    <HelpSite FormName="Database Maintenance" Module="26" />
                </div>
            </div>
            <div className="row mb-3" style={{ "marginLeft": "0px" }}>
                <label for="inputText" className="col-sm-2 col-form-label">Backup:</label>
                <div className="col-sm-1">
                    <button type="button" className="btn btn-primary " onClick={handleDownloadBackup}>
                        Backup
                    </button>
                </div>

            </div>

            <div className="row mb-3" style={{ "marginLeft": "0px" }}>
                <table className="table m-0 table-hover">
                    <thead>
                        <tr>

                            <th>Backup Taken</th>
                            <th>Download</th>


                        </tr>
                    </thead><tbody>
                        {DatabaseBackup.map((database, index) => (

                            <tr key={database.ID}>

                                <td> {formatDateWithFns(database.CreatedDate, activeDateFormat)}</td>
                                <td><button class='btn btn-sm btn-success'
                                    onClick={() =>
                                        handleDownload(
                                            database.FilePath,
                                            formatDateWithFns(database.CreatedDate, activeDateFormat)
                                        )
                                    }
                                    
                                >
                                    Download
                                </button></td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>

        </div>
    );
}

export default DatabasePage;
